var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{attrs:{"id":"footer"}},[_c('span',{staticClass:"footer-text"},[_vm._v(" COPYRIGHT "),_c('b',{staticStyle:{"color":"darkorange","text-decoration":"underline"}},[_vm._v("CMR INDÚSTRIA E COMÉRCIO")]),_vm._v(" 2023-2024. - v0.0.3 ")])])])
}]

export { render, staticRenderFns }